export default __webpack_public_path__ + "static/banner6-bfd914c28ee24c59309caad8f587e2cb.png";